import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';

import type { PublishError } from 'app/typings/publishError';
import { extractMissingFields } from 'app/utils/publishError';
import { apiMutation } from 'app/utils/request/api';

import { CORE_QUERY_KEYS, ENDPOINTS } from '.';

export function usePublishPack() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (packId: number) => {
      return apiMutation('POST', {
        path: ENDPOINTS.publishPack,
        params: { packId: packId.toString() },
      }) as Promise<void>;
    },
    onSuccess: (_, packId) => {
      message.success(`Package #${packId} published`);
      queryClient.invalidateQueries({
        queryKey: [CORE_QUERY_KEYS.packs],
        exact: false,
      });
    },
    onError: (error: PublishError, packId) => {
      if (extractMissingFields(error) !== null) {
        return;
      }

      message.error(`Error while publishing package #${packId}`);
    },
  });
}
